import { render, staticRenderFns } from "./iap-product-button.vue?vue&type=template&id=744d1305&"
import script from "./iap-product-button.vue?vue&type=script&lang=js&"
export * from "./iap-product-button.vue?vue&type=script&lang=js&"
import style0 from "./iap-product-button.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports